import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function listItem(theme: Theme): ComponentStyle {
  return {
    componentName: 'listItem',
    baseStyle: {
      padding: `${theme.space.s} 0`,
      borderBottom: `1px solid ${theme.colors.border15}`,
      color: theme.colors.text
    },
    variants: {
      selectable: {
        cursor: 'pointer',
        padding: `${theme.space.s} ${theme.space['2xs']}`,

        ['&:hover']: {
          backgroundColor: theme.colors.tableRowHover,
          color: theme.colors.text
        }
      },

      link: {
        cursor: 'pointer',
        padding: `${theme.space.s} ${theme.space['2xs']}`,

        ['&:hover']: {
          backgroundColor: theme.colors.tableRowHover,
          color: theme.colors.text
        }
      }
    }
  };
}
